module.exports = __webpack_public_path__ + "media/images/mobile/solutions/5-288c3f0b498a34bd7759847696ef5dad.png";